module.exports = __webpack_public_path__ + "img/bgR3.de77ecc9.png";